import { Schedule as ScheduleIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";

import { AddEventTimesDialog } from "./AddEventTimesDialog";
import { successGradientButtonSx } from "./AddEventTimesModal.theme";
import { type AddEventTimesModalProps } from "./AddEventTimesModal.types";

export const AddEventTimesModal = ({
  onSubmit,
  disabled = false,
  eventId,
  defaultDate,
  series,
}: AddEventTimesModalProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        aria-label="Add event times"
        disabled={disabled}
        onClick={() => setOpen(true)}
        size="small"
        startIcon={<ScheduleIcon />}
        sx={{
          minWidth: "auto",
          textTransform: "none",
          ...successGradientButtonSx,
        }}
        variant="contained"
        data-testid="add-meeting-times-button"
      >
        Create
      </Button>

      <AddEventTimesDialog
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={onSubmit}
        eventId={eventId}
        defaultDate={defaultDate}
        series={series}
      />
    </>
  );
};
